import styled from 'styled-components';
import Markdown from 'markdown-to-jsx';


export const StyledMarkdown = styled(Markdown)(({ theme }) => ({
  fontFamily: theme.fontFamily,
  fontSize: theme.fontSizes.body,
  lineHeight: theme.lineHeights.body,
  color: theme.colors.neutral['700'],

  p: {
    marginTop: 0,
    marginBottom: 8,
    '&:last-child': { marginBottom: 0 },
  },

  'ul, ol': {
    marginTop: 4,
    marginBottom: 8,
    paddingLeft: 24,
  },

  li: {
    marginBottom: 4,
  },

  strong: {
    fontWeight: 600,
    color: theme.colors.neutral['900'],
  },
}));
